/**
 * Hindi for messages the server sends back to the supervisor screens (errors on save, approvals,
 * money and cash book). Keys are the server's English text exactly; messages that carry a loom code,
 * saree number, time or amount are matched by pattern instead.
 */
export const HI_SERVER: Record<string, string> = {
  Forbidden: "आपको इसकी अनुमति नहीं है",
  FEATURE_DISABLED: "कारख़ाना इस स्टूडियो के लिए चालू नहीं है",
  "Not available": "उपलब्ध नहीं है",
  "Studio organisation is required": "स्टूडियो चुना होना ज़रूरी है",
  "Another supervisor or the studio admin must mark your attendance": "आपकी हाज़िरी दूसरा सुपरवाइज़र या स्टूडियो एडमिन लगाएगा",
  "Another supervisor or the studio admin must enter your work": "आपका काम दूसरा सुपरवाइज़र या स्टूडियो एडमिन लिखेगा",
  "Another supervisor or the studio admin must enter your pay": "आपका भुगतान दूसरा सुपरवाइज़र या स्टूडियो एडमिन लिखेगा",
  ENTRY_NOT_FOUND: "यह एंट्री नहीं मिली",
  CLOSURE_NOT_FOUND: "यह लूम-बंद एंट्री नहीं मिली",
  LOOM_NOT_FOUND: "यह लूम नहीं मिला",
  WORKER_NOT_FOUND: "यह कारीगर नहीं मिला",
  PUNCH_NOT_FOUND: "यह हाज़िरी एंट्री नहीं मिली",
  "This punch was removed or rejected. Refresh and check": "यह हाज़िरी एंट्री हटाई या नामंज़ूर की जा चुकी है। रीफ़्रेश करके देखें",
  "This is a work switch. Undo it and add it again at the new time": "यह काम बदलने की एंट्री है। इसे वापस लें और नए समय पर फिर से जोड़ें",
  PAY_ENTRY_NOT_FOUND: "यह भुगतान एंट्री नहीं मिली",
  PAY_SHEET_NOT_FOUND: "यह पे शीट नहीं मिली",
  "This pay sheet is a draft. The owner finalises it first, then people are paid from it":
    "यह पे शीट ड्राफ़्ट है। मालिक पहले इसे पक्का करें, फिर इससे भुगतान होगा",
  "This draft was discarded. Nobody is paid from it": "यह ड्राफ़्ट हटा दिया गया है। इससे भुगतान नहीं होगा",
  "This draft was discarded": "यह ड्राफ़्ट हटा दिया गया है",
  "This pay sheet is already final": "यह पे शीट पहले से पक्की है",
  "Only the studio owner can finalise or discard a pay sheet": "पे शीट सिर्फ़ स्टूडियो मालिक पक्की कर सकते हैं या हटा सकते हैं",
  CASH_ENTRY_NOT_FOUND: "यह कैश एंट्री नहीं मिली",
  SAREE_NOT_FOUND: "यह साड़ी नहीं मिली",
  DESIGN_NOT_FOUND: "यह डिज़ाइन नहीं मिला",
  WORK_TYPE_UNKNOWN: "यह काम का प्रकार नहीं पहचाना गया",
  ACTIVITY_NOT_FOUND: "यह काम नहीं मिला",
  JOB_ENTRY_NOT_FOUND: "यह ठेके का काम नहीं मिला",

  // Rounds
  "A saree number is digits only, e.g. 14500": "साड़ी नंबर में सिर्फ़ अंक हों, जैसे 14500",
  "Choose a design": "डिज़ाइन चुनें",
  "Choose the design": "डिज़ाइन चुनें",
  "Choose the weaver": "बुनकर चुनें",
  "Choose the helper, or mark the weaver as working alone": "हेल्पर चुनें, या बुनकर को अकेले काम करते हुए चिह्नित करें",
  "Choose the work type": "काम का प्रकार चुनें",
  "Choose why the loom is closed": "लूम बंद होने का कारण चुनें",
  "Choose one of your registered looms": "अपने रजिस्टर्ड लूम में से एक चुनें",
  "Choose one of your products": "अपने प्रोडक्ट में से एक चुनें",
  "Choose front, back, left or right": "आगे, पीछे, बाएँ या दाएँ चुनें",
  "Enter how many inches were woven": "कितने इंच बुने गए, लिखें",
  "Inches woven alone must be between 0 and the total": "अकेले बुने इंच 0 और कुल इंच के बीच हों",
  "The weaver and helper must be different people": "बुनकर और हेल्पर अलग-अलग लोग हों",
  "Work is already entered for this loom on that day": "इस लूम पर उस दिन का काम पहले से लिखा है",
  "You can't enter work for a future date": "आगे की तारीख़ का काम नहीं लिख सकते",
  "You can't open a future date": "आगे की तारीख़ नहीं खोल सकते",
  "You can't check in for a future date": "आगे की तारीख़ की जाँच नहीं लिख सकते",
  "Start a saree on this loom first": "पहले इस लूम पर साड़ी शुरू करें",
  "No saree is on this loom": "इस लूम पर कोई साड़ी नहीं है",
  "The loom's current saree started on or after that date": "लूम की मौजूदा साड़ी उस तारीख़ को या उसके बाद शुरू हुई",
  "The saree can't finish before it started": "साड़ी शुरू होने से पहले पूरी नहीं हो सकती",
  "Finish as COMPLETED, STOPPED or CUT": "पूरी, रुकी या कटी में से चुनें",
  "Helper must be WITH_HELPER, ALONE or NOT_NEEDED": "हेल्पर के साथ, अकेले या हेल्पर की ज़रूरत नहीं में से चुनें",
  "Saree numbers aren't set up yet. Ask the studio admin to set the first number":
    "साड़ी नंबर अभी सेट नहीं हैं। स्टूडियो एडमिन से पहला नंबर सेट करवाएँ",
  "Enter the first saree number, e.g. 14500": "पहला साड़ी नंबर लिखें, जैसे 14500",
  "Couldn't find a free saree number. Check the starting number": "कोई ख़ाली साड़ी नंबर नहीं मिला। शुरुआती नंबर जाँचें",
  "Unit must be m, in or girah": "इकाई मीटर, इंच या गिरह हो",
  "Link a product first": "पहले प्रोडक्ट जोड़ें",
  "The product wasn't created. Try again": "प्रोडक्ट नहीं बना। फिर से कोशिश करें",
  "Could not allocate a loom ID": "लूम ID नहीं बन पाई",
  "Add up to 500 looms at a time": "एक बार में 500 लूम तक जोड़ें",
  "Enter loom codes, e.g. N01-N44": "लूम कोड लिखें, जैसे N01-N44",
  "The photo didn't upload. Try again": "फ़ोटो अपलोड नहीं हुई। फिर से कोशिश करें",
  "The location didn't come through. Allow location on the phone and try again": "लोकेशन नहीं मिली। फ़ोन में लोकेशन चालू करके फिर कोशिश करें",
  "Upload a JPEG, PNG or HEIC photo": "JPEG, PNG या HEIC फ़ोटो अपलोड करें",
  "The voice note didn't upload. Record it again": "वॉइस नोट अपलोड नहीं हुआ। फिर से रिकॉर्ड करें",
  "Record an audio note (webm, mp4, mpeg or ogg)": "ऑडियो नोट रिकॉर्ड करें",
  "Ask the studio admin to remove entries older than 3 days": "3 दिन से पुरानी एंट्री स्टूडियो एडमिन से हटवाएँ",
  "Ask the studio admin to remove this": "इसे स्टूडियो एडमिन से हटवाएँ",
  "Say why this entry is being removed": "बताएँ कि यह एंट्री क्यों हटाई जा रही है",
  "Say why this is being removed": "बताएँ कि यह क्यों हटाया जा रहा है",
  "This entry isn't waiting for approval": "यह एंट्री मंज़ूरी के लिए बाकी नहीं है",
  "This closure isn't waiting for approval": "यह लूम-बंद एंट्री मंज़ूरी के लिए बाकी नहीं है",
  "Nothing is waiting for this day": "इस दिन की कोई मंज़ूरी बाकी नहीं है",

  // Attendance
  "Choose In or Out": "अंदर या बाहर चुनें",
  "Choose the person": "व्यक्ति चुनें",
  "Choose the work they are doing": "वे कौन-सा काम कर रहे हैं, चुनें",
  "Choose why they are going out": "बाहर जाने का कारण चुनें",
  "They are already on that work": "वे पहले से उसी काम पर हैं",
  "Enter the time": "समय लिखें",
  "Time must look like 09:30": "समय ऐसे लिखें: 09:30",
  "That time hasn't come yet": "वह समय अभी आया नहीं है",
  "A stretch can't be longer than 24 hours": "एक बार में 24 घंटे से ज़्यादा नहीं हो सकता",
  "Ask the studio admin to remove punches older than 3 days": "3 दिन से पुरानी हाज़िरी स्टूडियो एडमिन से हटवाएँ",
  "Say why this punch is being removed": "बताएँ कि यह हाज़िरी क्यों हटाई जा रही है",

  // Money and cash book
  "Choose payment, advance or recovery": "भुगतान, एडवांस या वसूली चुनें",
  "Choose cash, UPI or bank": "कैश, UPI या बैंक चुनें",
  "Enter the amount": "रक़म लिखें",
  "Enter amounts as numbers, e.g. 1250 or 1250.50": "रक़म अंकों में लिखें, जैसे 1250 या 1250.50",
  "You can't record money for a future date": "आगे की तारीख़ का पैसा नहीं लिख सकते",
  "You can't record cash for a future date": "आगे की तारीख़ का कैश नहीं लिख सकते",
  "Say why the account is being adjusted": "बताएँ कि खाते में बदलाव क्यों हो रहा है",
  "The adjustment can't be 0": "बदलाव 0 नहीं हो सकता",
  "Enter the adjustment, e.g. 250 or -250": "बदलाव लिखें, जैसे 250 या -250",
  "Enter how much is agreed to be cut at each payout": "हर भुगतान पर कितना कटेगा, लिखें",
  "This person isn't on the sheet": "यह व्यक्ति शीट पर नहीं है",
  "The sheet can't include future dates": "शीट में आगे की तारीख़ें नहीं हो सकतीं",
  "The first date is after the last date": "पहली तारीख़ आख़िरी तारीख़ के बाद है",
  "The start date is after the end date": "शुरू की तारीख़ आख़िरी तारीख़ के बाद है",
  "Choose one of your supervisors": "अपने सुपरवाइज़र में से एक चुनें",
  "Choose the supervisor": "सुपरवाइज़र चुनें",
  "Only the studio admin can approve rates": "रेट सिर्फ़ स्टूडियो एडमिन मंज़ूर कर सकते हैं",

  // Job work and tagged time work
  "Choose how it is counted: job, colour, saree, kg or piece": "गिनती कैसे होगी चुनें: काम, रंग, साड़ी, किलो या पीस",
  "Enter how many": "कितने, लिखें",
  "Enter the agreed rate": "तय रेट लिखें",
  "That amount looks too large": "यह रक़म बहुत ज़्यादा लगती है",
  "Choose the work, e.g. Dyeing": "काम चुनें, जैसे रंगाई",
  "This job work isn't waiting for approval": "यह ठेके का काम मंज़ूरी के लिए बाकी नहीं है",
  "Choose one of your looms": "अपने लूम में से एक चुनें",
  "Only the studio owner or admin can confirm workers": "वर्कर की पुष्टि सिर्फ़ स्टूडियो मालिक या एडमिन कर सकते हैं",
  "Ask the studio admin to change the design after work is entered": "काम लिखे जाने के बाद डिज़ाइन स्टूडियो एडमिन से बदलवाएँ",
};

type Pattern = [RegExp, (m: RegExpMatchArray) => string];

/** Server messages with a code, number, time or amount in them. */
export const HI_SERVER_PATTERNS: Pattern[] = [
  // Work counted before a payment can't change; work entered after it stays open.
  [/^(.+) was already paid for this work of (\S+) on a pay sheet\. Ask the studio admin to adjust their account instead$/, (m) =>
    `${m[1]} को ${m[2]} के इस काम का भुगतान पे शीट पर हो चुका है। खाते में बदलाव के लिए स्टूडियो एडमिन से कहें`],
  // Two phones saving the same thing at once
  [/^Loom (?:(\S+) )?was just saved by someone else(?: \((.+?) in(?: by (.+))?\))?\. Refresh and check$/, (m) =>
    `लूम ${m[1] || ""} अभी किसी और ने भर दिया${m[2] ? ` (${m[2]} इंच${m[3] ? `, ${m[3]}` : ""})` : ""}। रीफ़्रेश करके देखें`.replace("लूम  ", "लूम ")],
  [/^Loom (.+?) was closed(?: by (.+))?\. Refresh, or reopen it to save$/, (m) =>
    `लूम ${m[1]} बंद किया गया${m[2] ? ` (${m[2]} ने)` : ""}। रीफ़्रेश करें, या सेव करने के लिए लूम फिर से चालू करें`],
  [/^(.+) was just marked by someone else\. Refresh and check$/, (m) => `${m[1]} की हाज़िरी अभी किसी और ने लगाई। रीफ़्रेश करके देखें`],
  [/^(.+) was just changed by someone else\. Refresh and check$/, (m) => `${m[1]} की हाज़िरी अभी किसी और ने बदली। रीफ़्रेश करके देखें`],
  [/^(.+) can't have an (IN|OUT) at (\d\d:\d\d)\. Check the In and Out times$/, (m) => `${m[1]} की ${m[3]} पर ${m[2] === "IN" ? "इन" : "आउट"} नहीं हो सकती। इन और आउट के समय देखें`],
  [/^Ask the studio admin to remove punches (\d+) or more days old$/, (m) => `${m[1]} या ज़्यादा दिन पुरानी हाज़िरी स्टूडियो एडमिन से हटवाएँ`],
  [/^Ask the studio admin to change punches (\d+) or more days old$/, (m) => `${m[1]} या ज़्यादा दिन पुरानी हाज़िरी स्टूडियो एडमिन से बदलवाएँ`],
  // A worker a supervisor added: no money until the owner confirms them.
  [/^(.+) is waiting for the studio owner to confirm them\. Pay can be entered once the owner taps Confirm in Workers$/, (m) =>
    `${m[1]} की पुष्टि स्टूडियो मालिक को करनी है। मालिक के वर्कर्स में "पुष्टि करें" दबाने के बाद ही भुगतान लिखा जा सकता है`],
  [/^(.+) is being paid by someone else right now\. Refresh and check$/, (m) => `${m[1]} को अभी कोई और भुगतान कर रहा है। रीफ़्रेश करके देखें`],
  [/^(.+) is being added by someone else right now\. Search again in a moment$/, (m) => `${m[1]} को अभी कोई और जोड़ रहा है। थोड़ी देर में फिर खोजें`],
  [/^(.+) was just added as (.+)$/, (m) => `${m[1]} अभी ${m[2]} के रूप में जोड़े गए`],
  [/^No saree is on loom (.+) on that day\. Start one first\.$/, (m) => `उस दिन लूम ${m[1]} पर कोई साड़ी नहीं थी। पहले साड़ी शुरू करें।`],
  [/^No saree is on (.+)$/, (m) => `${m[1]} पर कोई साड़ी नहीं है`],
  [/^Saree (\d+) is already used\. Start at (\d+) or above$/, (m) => `साड़ी ${m[1]} पहले से इस्तेमाल हो चुकी है। ${m[2]} या उससे ऊपर से शुरू करें`],
  [/^Saree (\d+) already exists$/, (m) => `साड़ी ${m[1]} पहले से है`],
  [/^Saree (\d+) already has a product$/, (m) => `साड़ी ${m[1]} का प्रोडक्ट पहले से है`],
  [/^That product is already saree (\d+)$/, (m) => `यह प्रोडक्ट पहले से साड़ी ${m[1]} है`],
  [/^Saree (\d+) isn't in HKP yet\. Tag the loom instead$/, (m) => `साड़ी ${m[1]} अभी HKP में नहीं है। लूम चुनें`],
  [/^Saree (\d+) isn't in HKP yet$/, (m) => `साड़ी ${m[1]} अभी HKP में नहीं है`],
  [/^Add up to (\d+) sarees at a time$/, (m) => `एक बार में ${m[1]} साड़ियों तक जोड़ें`],
  [/^(.+) job work waits for the admin's approval$/, (m) => `${m[1]} का ठेके का काम एडमिन की मंज़ूरी के लिए बाकी है`],
  [/^Saree (\d*) has only ([\d.,]+) in entered; a full saree is about ([\d.,]+) in\. Check the length and the entries before marking it complete$/,
    (m) => `साड़ी ${m[1]} की अभी सिर्फ़ ${m[2]} इंच एंट्री है; पूरी साड़ी लगभग ${m[3]} इंच होती है। पूरी करने से पहले लंबाई और एंट्री जाँचें`],
  [/^That registered loom is already (.+)$/, (m) => `यह रजिस्टर्ड लूम पहले से ${m[1]} है`],
  [/^These people already changed on (.+)$/, (m) => `ये लोग ${m[1]} को पहले ही बदले जा चुके हैं`],
  [/^Not in at (\d{1,2}:\d{2})\. Mark them In first$/, (m) => `${m[1]} पर अंदर नहीं थे। पहले अंदर लगाएँ`],
  [/^(\S+) already has a punch at (\d{1,2}:\d{2})\. Pick another minute, or undo that punch$/, (m) => `${m[1]} की ${m[2]} पर पहले से हाज़िरी है। दूसरा मिनट चुनें, या वह हाज़िरी हटाएँ`],
  [/^(\S+) has an In at (\d{1,2}:\d{2}) after this\. Add the Out before it first$/, (m) => `${m[1]} का इसके बाद ${m[2]} पर अंदर है। पहले उससे पहले बाहर लगाएँ`],
  [/^(\S+) isn't in at (\d{1,2}:\d{2})\. Mark them In instead$/, (m) => `${m[1]} ${m[2]} पर अंदर नहीं हैं। अंदर लगाएँ`],
  [/^Only ₹(.+) is in hand$/, (m) => `हाथ में सिर्फ़ ₹${m[1]} हैं`],
  [/^That is more than the wages due \(₹(.+)\)\. Give the extra as an advance$/, (m) => `यह बकाया मज़दूरी (₹${m[1]}) से ज़्यादा है। बाकी एडवांस में दें`],
  [/^Cut \+ paid can't be more than the wages due \(₹(.+)\)$/, (m) => `कटौती + भुगतान बकाया मज़दूरी (₹${m[1]}) से ज़्यादा नहीं हो सकता`],
  [/^Cut at most ₹(.+) for the advance$/, (m) => `एडवांस के लिए ज़्यादा से ज़्यादा ₹${m[1]} काटें`],
  [/^Recover at most ₹(.+) \(advance still owed ₹(.+), wages due ₹(.+)\)$/, (m) => `ज़्यादा से ज़्यादा ₹${m[1]} वसूलें (एडवांस बाकी ₹${m[2]}, मज़दूरी बकाया ₹${m[3]})`],
  [/^(\S+)'s account changed since the sheet was made \(now ₹(.+) due\)\. Refresh the sheet and print it again$/, (m) => `शीट बनने के बाद ${m[1]} का खाता बदला है (अब ₹${m[2]} बकाया)। शीट रीफ़्रेश करके फिर प्रिंट करें`],
];

/** Hindi for a server message, or undefined when it isn't known. */
export const serverHindi = (text: string): string | undefined => {
  const exact = HI_SERVER[text] ?? HI_SERVER[text.replace(/[.!\s]+$/, "")];
  if (exact) return exact;
  for (const [re, fn] of HI_SERVER_PATTERNS) {
    const m = text.match(re);
    if (m) return fn(m);
  }
  return undefined;
};
